import styled from 'styled-components/macro';

export const Container = styled.div< {whiteBackground: boolean} >`
    height: 100%;
    width: 100%;
    position: relative;
    background: ${p => p.whiteBackground ? '#ffffff' : 'unset'};
    overflow: auto;
`;
